$(function () {
	$('body').on('click', '.topiclist input[type=radio]', function(){
		document.location.href = $(this).data('url');
	});
});



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/contactwizard.js
// module id = 114
// module chunks = 0